import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { fetchPlacementRules } from "../../../services/automapFeaturedPlacementApi";
import { AdminPlacementsNav } from "./AdminPlacementsShared";

export default function AdminPlacementRulesPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchPlacementRules()
      .then((payload) => setData(payload.rules))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const rules = data?.rules || data;

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Destacados" title="Reglas de placement" description="Elegibilidad, etiquetado y slots (solo lectura)." />
      <AdminAutomotiveNav active="placements" />
      <AdminPlacementsNav active="rules" />
      <main className="admin-console__main wrap">
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {rules ? (
          <>
            <section className="dealer-state-box">
              <h3>Planes elegibles</h3>
              <ul>{(rules.eligiblePlans || []).map((p) => <li key={p}>{p}</li>)}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Requisitos de listing</h3>
              <ul>{(rules.listingRequirements || []).map((r) => <li key={r}>{r}</li>)}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Requisitos de dealer</h3>
              <ul>{(rules.dealerRequirements || []).map((r) => <li key={r}>{r}</li>)}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Etiquetado público</h3>
              <p>{rules.labeling?.primaryLabel} — {rules.labeling?.tooltip}</p>
            </section>
            <section className="dealer-state-box">
              <h3>Slots</h3>
              <div className="import-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Slot</th>
                      <th>Página</th>
                      <th>Máx.</th>
                      <th>Descripción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(data.slots || []).map((slot) => (
                      <tr key={slot.slotKey}>
                        <td>{slot.slotKey}</td>
                        <td>{slot.pageType}</td>
                        <td>{slot.maxItems}</td>
                        <td>{slot.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            <p className="muted">{data.note || rules.schedulingNote}</p>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
